import React from 'react';
import * as d from "../../reducers/domainReducer";
import { connect } from 'react-redux';
import { getFirstName } from "../../helpers/formatting";
import { Link } from "react-router-dom";
import NotAuthorized from '../common/NotAuthorized';

function PrayerWallNotAuthorized({ currentUser, myChartRegistrationUrl }) {
    let currentUserName = currentUser && currentUser.displayName ? `${getFirstName(currentUser.displayName)}'s` : 'The';
    return (
        <NotAuthorized
            className="prayerfeature__not-authorized"
            message={
                <>{currentUserName} Community Support wall must be accessed through their own MyBSWHealth account.
                    If they do not have one, it can be created <Link to={{ pathname: myChartRegistrationUrl }} target="_blank">here</Link>.
                </>
            }
        />
    );
}

const mapStateToProps = state => {
    return {
        currentUser: d.hydrateProxyUser(state.domain.cu),
        myChartRegistrationUrl: state.session.serverData ? state.session.serverData.myChartRegistrationUrl : ""
    };
};

export default connect(mapStateToProps)(PrayerWallNotAuthorized);